module.exports = __webpack_public_path__ + "img/app_icon.98acc364.png";